import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SolidEyeIcon } from '@streamr/tv-ui';
import styled from 'styled-components';
import { ViewerCountService } from '../services/viewercount/ViewerCountService';
import { Badge as PrestyledBadge } from './Ui';
export function LiveIndicator({ className }) {
    const viewerCount = ViewerCountService.getOutput().useViewerCountForActiveBroadcast();
    return (_jsxs(LiveIndicatorRoot, { className: className, children: [_jsx(LiveBadge, { children: "Live" }), viewerCount !== undefined && (_jsxs(ViewerCountBadge, { children: [_jsx(SolidEyeIcon, {}), viewerCount] }))] }));
}
const Badge = styled(PrestyledBadge) `
    align-items: center;
    backdrop-filter: var(--tv-LiveIndicator-backdrop-filter, none);
    background: var(--tv-LiveIndicator-background);
    color: var(--tv-ui-color-3);
    display: flex;
    font-size: 0.875rem;
    height: 1.75rem;
    padding: 0 0.5rem;
    font-weight: 500;
    gap: 0.25rem;
`;
const LiveBadge = styled(Badge) `
    --tv-LiveIndicator-background: var(--tv-ui-color-6);
`;
const ViewerCountBadge = styled(Badge) `
    --tv-LiveIndicator-background: rgba(0, 0, 0, 0.08);
    --tv-LiveIndicator-backdrop-filter: blur(10px);
`;
const LiveIndicatorRoot = styled.div `
    align-items: center;
    gap: 0.25rem;
    display: none;
    height: 100%;
    user-select: none;

    @media (min-width: 20rem) {
        display: flex;
    }
`;
